import { ActionContext, ActionTree, GetterTree, Module, MutationTree } from 'vuex';
import { useToast } from 'vue-toastification';
import { RootState } from '..';
import { EmergencyType } from './emergencyType.model';
import emergencyTypeService from './emergencyType.service';

// namespace
export const EMERGENCY_TYPE_STORE_NAMESPACE = 'emergencyTypeStore';

// state
interface EmergencyTypeState {
  emergencyTypes: EmergencyType[];
  status: 'init' | 'idle' | 'loading' | 'failed';
}

const initialState: EmergencyTypeState = {
  emergencyTypes: [],
  status: 'init'
};

// mutation
const mutationConstant = {
  FETCH: 'fetch',
  PENDING: 'pending',
  FULFILLED: 'fulfilled',
  REJECTED: 'rejected'
};

const mutation: MutationTree<EmergencyTypeState> = {
  [mutationConstant.FETCH]: (state: EmergencyTypeState, emergencyTypes: EmergencyType[]) => {
    state.emergencyTypes = emergencyTypes;
  },
  [mutationConstant.PENDING]: (state: EmergencyTypeState) => {
    state.status = 'loading';
  },
  [mutationConstant.FULFILLED]: (state: EmergencyTypeState) => {
    state.status = 'idle';
  },
  [mutationConstant.REJECTED]: (state: EmergencyTypeState) => {
    state.status = 'failed';
    window.location.href = '/';
  },
};

// action
const toast = useToast();
const actionConstant = {
  FETCH: 'fetch'
};

const action: ActionTree<EmergencyTypeState, RootState> = {
  [actionConstant.FETCH](context: ActionContext<EmergencyTypeState, RootState>) {
    return new Promise<void>((resolve, reject) => {
      context.commit(mutationConstant.PENDING);
      emergencyTypeService.Fetch()
        .then((response) => {
          context.commit(mutationConstant.FETCH, response.data);
          context.commit(mutationConstant.FULFILLED);
          resolve();
        })
        .catch(() => {
          context.commit(mutationConstant.REJECTED);
          toast.error('ไม่สามารถเรียกข้อมูลได้');
          reject();
        });
    });
  }
};

// getter
const getterConstant = {
  ALL: 'all',
  BY_ID: 'byId',
  STATUS: 'status'
};

const getter: GetterTree<EmergencyTypeState, RootState> = {
  [getterConstant.ALL]: (state: EmergencyTypeState) => state.emergencyTypes,
  [getterConstant.BY_ID]: (state: EmergencyTypeState) => (id: number) => state.emergencyTypes.find(m => m.id === id),
  [getterConstant.STATUS]: (state: EmergencyTypeState) => state.status,
};

// module
const module: Module<EmergencyTypeState, RootState> = {
  namespaced: true,
  state: initialState,
  mutations: mutation,
  actions: action,
  getters: getter
};

// export
export const EmergencyTypeGetter = {
  ALL: `${EMERGENCY_TYPE_STORE_NAMESPACE}/${getterConstant.ALL}`,
  BY_ID: `${EMERGENCY_TYPE_STORE_NAMESPACE}/${getterConstant.BY_ID}`,
  STATUS: `${EMERGENCY_TYPE_STORE_NAMESPACE}/${getterConstant.STATUS}`
};

export const EmergencyTypeAction = {
  FETCH: `${EMERGENCY_TYPE_STORE_NAMESPACE}/${actionConstant.FETCH}`
};

export default module;
